import React, { useState, useContext } from "react";
import Fade from "react-reveal/Fade";
import { Navbar } from "react-bootstrap";
import Logo from "../../components/assets/logo.png";
import Wave from "../../components/assets/wave.png";
import { useSnackbar } from "notistack";
import Cookies from "js-cookie";
import axios from "axios";
import { UserContext } from "../../components/UserContext";
const url = "https://www.bitmasta.io/php/admin_pass.php";

function AdminLogin(props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const user = useContext(UserContext);

  const processSubmit =  (e) => {
    e.preventDefault();
    if (email && password) {
      let formData = new FormData();
      formData.append("Login_Email", email);
      formData.append("Login_Pass", password);
       axios
        .post(url, formData)
        .then((res) => {
          if (res.data.status === "Account Error")
            enqueueSnackbar(res.data.message, {
              variant: "error",
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
              },
            });
          else if (res.data.status === "Login Successful") {
            enqueueSnackbar(res.data.status, {
              variant: "success",
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
              },
            });
            Cookies.set("admin--auth", res.data.Session, { expires: 1 });
            if (Cookies.get("admin--auth")) user.setAdmin(Cookies.get("admin--auth"));
            props.history.push("/admin/dashboard");
          }
        })
        .catch((err) =>
          enqueueSnackbar("No internet connection", {
            variant: "error",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "right",
            },
          })
        );
    } else {
      enqueueSnackbar("All fields are required", {
        variant: "error",
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      });
    }
  };
  return (
    <div className="h-100">
      <Navbar className="bts-landing-page-caption-logo" expand="lg" fixed="top">
        <Navbar.Brand href="/">
          <img src={Logo} alt="" />
        </Navbar.Brand>
      </Navbar>
      <div style={{height:"100vh"}} className="bts-landing-page-caption-section position-relative w-100">
        <div className="d-flex justify-content-center h-100 flex-column">
        <Fade bottom delay={1000}>
          <div className="text-center whiteText b7 mediumText">
            Hey Admin! Welcome
            <br />
            Back &nbsp;
            <img src={Wave} alt="" />
          </div>
        </Fade>
        <Fade bottom delay={1200}>
          <p className="whiteText text-center pt-2 b3 medText">
            How is your day going?
          </p>
        </Fade>
        <Fade bottom delay={1500}>
          <div className="pt text-center">
            <form onSubmit={processSubmit}>
              <div>
                <input
                  type="email"
                  name=""
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  placeholder="Your email"
                  id="emailInput"
                />
              </div>
              <div>
                <input
                  type="password"
                  name=""
                  onChange={(e) => setPassword(e.target.value)}
                  value={password}
                  placeholder="Password"
                  id="pppppp"
                  className="mt-4"
                />
              </div>
              <div>
                <button type="submit" className="submitButton mt-2">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </Fade>
        </div>
      </div>
     </div>
  );
}

export default AdminLogin;
